<template>
  <v-container fluid>
    <h1 class="display-inline">Jobs Audit Report</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>

    <v-row>
      <v-col cols="12">
        <JobsAuditReport></JobsAuditReport>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import JobsAuditReport from "../components/jobs/JobsAuditReport"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";

export default {
  name: "JobsAuditReportPage",
  permissions: [...JobsAuditReport.permissions],
  components: {
    ActiveApiCalls,
    JobsAuditReport
  },
  methods: {},
  mounted() {
  },
  data() {
    return {}
  },
}

</script>

<style scoped>

</style>